import {
  BOOKING_BEFORE_MEETING_STARTED,
  BOOKING_WHEN_INVITEE_BOOKED,
  BOOKING_WHEN_INVITEE_NO_SHOW,
  BOOKING_WHEN_MEETING_CANCELED,
  BOOKING_WHEN_MEETING_FINISHED,
  BOOKING_WHEN_MEETING_RESCHEDULED,
  BOOKING_WHEN_MEETING_SCHEDULED,
  BOOKING_WHEN_MEETING_STARTED,
  DEFAULT_TIME,
  DEFAULT_UNITS,
} from './consts'
import { GroupTriggers } from './group_triggers'
import { TimingBlock } from './styles'
import { Timing } from './timing'
import { TriggerSelect } from './trigger_select'

const defaultTimings = {
  [BOOKING_WHEN_INVITEE_BOOKED]: [0],
  [BOOKING_WHEN_INVITEE_NO_SHOW]: [0],
  [BOOKING_BEFORE_MEETING_STARTED]: [DEFAULT_TIME, DEFAULT_UNITS],
  [BOOKING_WHEN_MEETING_SCHEDULED]: [0],
  [BOOKING_WHEN_MEETING_STARTED]: [0],
  [BOOKING_WHEN_MEETING_FINISHED]: [0],
  [BOOKING_WHEN_MEETING_CANCELED]: [0],
  [BOOKING_WHEN_MEETING_RESCHEDULED]: [0]
}

export const TriggerEdit = ({
  triggerType,
  timeValue,
  timeUnits,
  onChange,
  onError,
  selectInvalid,
  selectError,
}) => {
  function onTriggerTypeChange(newTriggerType) {
    onChange(newTriggerType, ...defaultTimings[newTriggerType])
  }

  function onTimingChange(value, units) {
    onChange(triggerType, value, units)
  }

  return (
    <>
      <TriggerSelect
        value={triggerType}
        onChange={onTriggerTypeChange}
        invalid={selectInvalid}
        error={selectError}
      />
      <TimingBlock>
        <Timing
          triggerType={triggerType}
          value={timeValue}
          units={timeUnits}
          onChange={onTimingChange}
          onError={onError}
        />
      </TimingBlock>
      <GroupTriggers
        triggerType={triggerType}
        onChange={onTriggerTypeChange}
      />
    </>
  )
}
